export default __webpack_public_path__ + "static/media/img-mechanism.2c88250d.jpg";